import { motion } from "framer-motion";

const Reveal = ({ children, delay = 0, y = 30, tilt = 8, className = "" }) => (
  <motion.div
    className={className}
    style={{ transformPerspective: 1000 }}
    initial={{ opacity: 0, y, rotateX: tilt }}
    whileInView={{ opacity: 1, y: 0, rotateX: 0 }}
    viewport={{ once: true, amount: 0.2 }}
    transition={{ duration: 0.65, delay, ease: "easeOut" }}
  >
    {children}
  </motion.div>
);

export default Reveal;
